(() => {
  const read = key => { try { return localStorage.getItem(key) === '1'; } catch { return false; } };
  const save = (key, value) => { try { localStorage.setItem(key, value ? '1' : '0'); } catch {} };
  const applyPreference = (key, className, selector) => {
    document.documentElement.classList.toggle(className, read(key));
    document.querySelectorAll(selector).forEach(button => {
      button.setAttribute('aria-pressed', String(read(key)));
      if (button.dataset.spReady) return;
      button.dataset.spReady = 'true';
      button.addEventListener('click', () => {
        const enabled = !document.documentElement.classList.contains(className);
        document.documentElement.classList.toggle(className, enabled);
        save(key, enabled);
        document.querySelectorAll(selector).forEach(item => item.setAttribute('aria-pressed', String(enabled)));
      });
    });
  };
  const initPreferences = () => {
    applyPreference('sp-text', 'sp-large-text', '[data-sp-text]');
    applyPreference('sp-contrast', 'sp-high-contrast', '[data-sp-contrast]');
  };
  if (!customElements.get('senior-phone-shop')) customElements.define('senior-phone-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = [...this.querySelectorAll('[data-sp-card]')];
      this.filter = this.querySelector('[data-sp-filter]');
      this.count = this.querySelector('[data-sp-count]');
      this.dataset.spEnhanced = 'true';
      const categories = [...this.querySelectorAll('[data-sp-category]')];
      const filterCards = () => {
        let visible = 0;
        this.cards.forEach(card => { card.hidden = this.filter.value !== 'all' && card.dataset.form !== this.filter.value; if (!card.hidden) visible++; });
        this.count.textContent = this.dataset.countLabel.replace('[count]', String(visible));
        categories.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.spCategory === this.filter.value)));
      };
      this.filter.addEventListener('change', filterCards);
      categories.forEach(button => button.addEventListener('click', () => {
        this.filter.value = button.dataset.spCategory;
        filterCards();
      }));
      this.querySelectorAll('[data-sp-browse]').forEach(link => link.addEventListener('click', () => {
        this.filter.value = link.dataset.spBrowse;
        filterCards();
      }));
      this.querySelector('.sp-hero-caption')?.addEventListener('click', () => {
        this.filter.value = 'all';
        filterCards();
      });
      filterCards();
      const sorter = this.querySelector('[data-sp-sort]');
      if (sorter) sorter.addEventListener('change', () => {
        const ordered = [...this.cards];
        if (sorter.value !== 'featured') ordered.sort((a, b) => sorter.value === 'price-up' ? Number(a.dataset.price) - Number(b.dataset.price) : Number(b.dataset.price) - Number(a.dataset.price));
        const catalog = this.querySelector('.sp-catalog');
        ordered.forEach(card => catalog.append(card));
      });
      const chooser = this.querySelector('[data-sp-chooser]');
      const syncScreenChoice = () => {
        const isBar = chooser.querySelector('[name="form"]:checked').value === 'bar';
        const screen = chooser.querySelector('[data-sp-outer]');
        screen.disabled = isBar;
        screen.hidden = isBar;
        chooser.querySelector('[data-sp-outer-note]').hidden = !isBar;
        if (isBar) screen.querySelector('[value="any"]').checked = true;
      };
      chooser.addEventListener('change', () => { syncScreenChoice(); this.querySelector('[data-sp-result]').replaceChildren(); });
      chooser.addEventListener('reset', () => { requestAnimationFrame(() => { syncScreenChoice(); this.querySelector('[data-sp-result]').replaceChildren(); }); });
      syncScreenChoice();
      chooser.addEventListener('submit', event => {
        event.preventDefault();
        const form = new FormData(event.currentTarget);
        const matches = this.cards.filter(card => card.dataset.available === 'true' && (form.get('form') === 'all' || card.dataset.form === form.get('form')) && (form.get('outer') !== 'yes' || card.dataset.outer === 'true') && (form.get('budget') === 'all' || Number(card.dataset.price) <= Number(form.get('budget'))));
        const result = this.querySelector('[data-sp-result]');
        result.replaceChildren();
        const intro = document.createElement('p');
        intro.textContent = matches.length ? (matches.length === 1 ? this.dataset.matchOne : this.dataset.matchMany.replace('[count]', String(matches.length))) : this.dataset.noMatchLabel;
        result.append(intro);
        if (!matches.length) { const note = document.createElement('a'); note.href = this.dataset.contactUrl; note.textContent = this.dataset.helpLabel; result.append(note); }
        matches.forEach(card => {
          const link = document.createElement('a'); link.href = card.dataset.productUrl || '#' + card.id; link.className = 'sp-result-link';
          const originalImage = card.querySelector('.sp-card-media img');
          if (originalImage) {
            const thumbnail = originalImage.cloneNode(false);
            thumbnail.alt = ''; thumbnail.width = 64; thumbnail.height = 76;
            thumbnail.sizes = '64px'; thumbnail.loading = 'lazy';
            link.append(thumbnail);
          }
          const copy = document.createElement('span'); copy.className = 'sp-result-copy';
          const title = document.createElement('strong'); title.textContent = card.dataset.name;
          copy.append(title);
          const price = card.querySelector('.sp-price');
          if (price) { const amount = document.createElement('small'); amount.textContent = price.textContent.trim(); copy.append(amount); }
          const reason = document.createElement('span'); reason.className = 'sp-result-reason';
          const reasons = [card.dataset.reason];
          if (form.get('outer') === 'yes') reasons.push(this.dataset.reasonOuter);
          if (form.get('form') !== 'all') reasons.push(form.get('form') === 'bar' ? this.dataset.reasonBar : this.dataset.reasonFlip);
          if (form.get('budget') !== 'all') reasons.push(this.dataset.reasonBudget);
          reason.textContent = reasons.filter(Boolean).join(' ');
          copy.append(reason);
          link.append(copy);
          link.addEventListener('click', () => { this.filter.value = 'all'; filterCards(); });
          result.append(link);
        });
        result.focus({ preventScroll: true });
        result.scrollIntoView({ block: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
      const updateCompare = () => {
        const chosen = [...this.querySelectorAll('[data-sp-compare]:checked')].map(input => input.value);
        this.querySelectorAll('[data-sp-column]').forEach(cell => { cell.hidden = chosen.length > 0 && !chosen.includes(cell.dataset.spColumn); });
        const tray = this.querySelector('[data-sp-compare-tray]');
        tray.hidden = chosen.length === 0;
        tray.querySelector('[data-sp-selected-count]').textContent = chosen.length === 1 ? tray.dataset.singular : tray.dataset.plural.replace('[count]', String(chosen.length));
      };
      this.querySelectorAll('[data-sp-compare]').forEach(input => input.addEventListener('change', updateCompare));
      this.querySelectorAll('[data-sp-compare-reset]').forEach(button => button.addEventListener('click', () => { const restoreFocus = button.closest('[data-sp-compare-tray]') ? this.querySelector('[data-sp-compare]:checked') : null; this.querySelectorAll('[data-sp-compare]').forEach(input => { input.checked = false; }); updateCompare(); if (restoreFocus) restoreFocus.focus(); }));
    }
  });
  const animateSections = () => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.animate([{opacity: .65, transform: 'translateY(12px)'}, {opacity: 1, transform: 'translateY(0)'}], {duration: 420, easing: 'cubic-bezier(.2,.65,.3,1)'});
      observer.unobserve(entry.target);
    }), {threshold: .1});
    document.querySelectorAll('.sp-card, .sp-discover-card, .sp-feature-story, .sp-detail-panel, .sp-model-benefit, .sp-model-editorial, .sp-guide-grid article').forEach(el => observer.observe(el));
  };
  animateSections();
  const modelSelect = document.querySelector('[data-sp-contact-model]');
  if (modelSelect) {
    const model = new URLSearchParams(location.search).get('model');
    if ([...modelSelect.options].some(option => option.value === model)) modelSelect.value = model;
  }
  initPreferences();
  document.addEventListener('shopify:section:load', initPreferences);
  document.addEventListener('click', event => {
    const link = event.target.closest('cart-drawer .drawer__inner-empty a.button');
    if (link) link.closest('cart-drawer').close();
  });
})();


